import React from 'react';

function FooterFishIllustration() {
  return (
    <svg
      aria-hidden='true'
      focusable='false'
      viewBox='150 0 300 150'
      className='sbf-divider__fish'
    >
      <defs>
        <linearGradient id='sbf-fishfill' x1='0' y1='0' x2='0' y2='1'>
          <stop offset='0' stopColor='#ffffff' />
          <stop offset='.55' stopColor='#dceefb' />
          <stop offset='1' stopColor='#7fbbe3' />
        </linearGradient>
        <linearGradient id='sbf-crown' x1='0' y1='0' x2='0' y2='1'>
          <stop offset='0' stopColor='#ffffff' />
          <stop offset='1' stopColor='#dceefb' stopOpacity='.75' />
        </linearGradient>
        <clipPath id='sbf-clip'>
          <path d='M55.8,31.35c-7.3,11.86-31.07,13.79-41.99,3.64l-3.63,3.16c-.33.28-.83.18-1.03-.21l-1.71-3.45c-.04-.09-.05-.19-.03-.28.01-.05.04-.1.08-.14l3.1-3.44h.01s0,0,0,0h0s-3.1-3.43-3.1-3.43c-.04-.04-.07-.09-.08-.14-.02-.09-.01-.19.03-.28l1.71-3.45c.19-.39.7-.49,1.03-.21l3.61,3.14c10.91-10.17,34.71-8.24,42.01,3.62.27.44.27,1.02,0,1.46Z' />
        </clipPath>
      </defs>
      <g className='sbf-fish__ripples'>
        <ellipse
          cx='240'
          cy='122'
          rx='30'
          ry='4.6'
          fill='#4595cf'
          fillOpacity='.3'
          stroke='#dceefb'
          strokeOpacity='.75'
          strokeWidth='1.5'
        />
        <ellipse
          cx='240'
          cy='122.8'
          rx='54'
          ry='7.6'
          fill='none'
          stroke='#b6d9f2'
          strokeOpacity='.42'
          strokeWidth='1.5'
        />
        <ellipse
          cx='240'
          cy='123.6'
          rx='80'
          ry='10.6'
          fill='none'
          stroke='#b6d9f2'
          strokeOpacity='.2'
          strokeWidth='1.5'
        />
      </g>
      <g className='sbf-fish__splash'>
        <path
          d='M214 122C214 108 204.4 101 206 94C207.6 101 226 108 226 122Z'
          fill='#b6d9f2'
          fillOpacity='.55'
        />
        <path
          d='M226 122C226 101 222.4 87 224 80C225.6 87 238 101 238 122Z'
          fill='#b6d9f2'
          fillOpacity='.55'
        />
        <path
          d='M234 122C234 98 238.4 81 240 74C241.6 81 246 98 246 122Z'
          fill='#b6d9f2'
          fillOpacity='.55'
        />
        <path
          d='M242 122C242 101 254.4 87 256 80C257.6 87 254 101 254 122Z'
          fill='#b6d9f2'
          fillOpacity='.55'
        />
        <path
          d='M254 122C254 108 272.4 101 274 94C275.6 101 266 108 266 122Z'
          fill='#b6d9f2'
          fillOpacity='.55'
        />
        <path
          d='M274 78C264 86 256 96 252 110L258 110C260 98 266 90 276 84Z'
          fill='#dceefb'
          fillOpacity='.5'
        />
        <path
          d='M221.5 122C221.5 111 214.4 107 216 100C217.6 107 230.5 111 230.5 122Z'
          fill='url(#sbf-crown)'
          fillOpacity='1'
        />
        <path
          d='M231.5 122C231.5 105 230.4 95 232 88C233.6 95 240.5 105 240.5 122Z'
          fill='url(#sbf-crown)'
          fillOpacity='1'
        />
        <path
          d='M239.5 122C239.5 105 246.4 95 248 88C249.6 95 248.5 105 248.5 122Z'
          fill='url(#sbf-crown)'
          fillOpacity='1'
        />
        <path
          d='M249.5 122C249.5 111 262.4 107 264 100C265.6 107 258.5 111 258.5 122Z'
          fill='url(#sbf-crown)'
          fillOpacity='1'
        />
        <path
          d='M212 122C220 114.5 260 114.5 268 122Z'
          fill='#ffffff'
          fillOpacity='.92'
        />
        <path
          d='M0 -6C2.6 -2.4 3.6 0 3.6 1.6A3.6 3.6 0 0 1 -3.6 1.6C-3.6 0 -2.6 -2.4 0 -6Z'
          fill='#dceefb'
          fillOpacity='0.85'
          transform='translate(202 86) rotate(-38) scale(0.9)'
        />
      </g>
      <g className='sbf-fish__drops'>
        <path
          d='M0 -6C2.6 -2.4 3.6 0 3.6 1.6A3.6 3.6 0 0 1 -3.6 1.6C-3.6 0 -2.6 -2.4 0 -6Z'
          fill='#dceefb'
          fillOpacity='0.9'
          transform='translate(216 68) rotate(-18) scale(1)'
        />
        <path
          d='M0 -6C2.6 -2.4 3.6 0 3.6 1.6A3.6 3.6 0 0 1 -3.6 1.6C-3.6 0 -2.6 -2.4 0 -6Z'
          fill='#dceefb'
          fillOpacity='0.9'
          transform='translate(240 62) rotate(0) scale(1.1)'
        />
        <path
          d='M0 -6C2.6 -2.4 3.6 0 3.6 1.6A3.6 3.6 0 0 1 -3.6 1.6C-3.6 0 -2.6 -2.4 0 -6Z'
          fill='#dceefb'
          fillOpacity='0.85'
          transform='translate(264 68) rotate(18) scale(1)'
        />
        <path
          d='M0 -6C2.6 -2.4 3.6 0 3.6 1.6A3.6 3.6 0 0 1 -3.6 1.6C-3.6 0 -2.6 -2.4 0 -6Z'
          fill='#dceefb'
          fillOpacity='0.8'
          transform='translate(280 86) rotate(38) scale(0.9)'
        />
        <path
          d='M0 -6C2.6 -2.4 3.6 0 3.6 1.6A3.6 3.6 0 0 1 -3.6 1.6C-3.6 0 -2.6 -2.4 0 -6Z'
          fill='#dceefb'
          fillOpacity='0.7'
          transform='translate(194 104) rotate(-55) scale(0.6)'
        />
        <path
          d='M0 -6C2.6 -2.4 3.6 0 3.6 1.6A3.6 3.6 0 0 1 -3.6 1.6C-3.6 0 -2.6 -2.4 0 -6Z'
          fill='#dceefb'
          fillOpacity='0.65'
          transform='translate(288 104) rotate(55) scale(0.6)'
        />
        <circle cx='228' cy='60' r='1.6' fill='#ffffff' fillOpacity='.75' />
        <circle cx='254' cy='56' r='1.3' fill='#ffffff' fillOpacity='.7' />
        <circle cx='208' cy='96' r='1.4' fill='#ffffff' fillOpacity='.7' />
        <path
          d='M0 -6L1.3 -1.3 6 0 1.3 1.3 0 6 -1.3 1.3 -6 0 -1.3 -1.3Z'
          fill='#ffffff'
          fillOpacity='0.65'
          transform='translate(192 70) scale(0.6)'
        />
      </g>
      <g className='sbf-fish__body'>
        <g transform='translate(324 62) rotate(-16) scale(2.3) translate(-31 -31)'>
          <path
            d='M55.8,31.35c-7.3,11.86-31.07,13.79-41.99,3.64l-3.63,3.16c-.33.28-.83.18-1.03-.21l-1.71-3.45c-.04-.09-.05-.19-.03-.28.01-.05.04-.1.08-.14l3.1-3.44h.01s0,0,0,0h0s-3.1-3.43-3.1-3.43c-.04-.04-.07-.09-.08-.14-.02-.09-.01-.19.03-.28l1.71-3.45c.19-.39.7-.49,1.03-.21l3.61,3.14c10.91-10.17,34.71-8.24,42.01,3.62.27.44.27,1.02,0,1.46Z'
            fill='#0a2135'
            fillOpacity='.45'
            transform='translate(1 1.4)'
          />
          <path
            d='M55.8,31.35c-7.3,11.86-31.07,13.79-41.99,3.64l-3.63,3.16c-.33.28-.83.18-1.03-.21l-1.71-3.45c-.04-.09-.05-.19-.03-.28.01-.05.04-.1.08-.14l3.1-3.44h.01s0,0,0,0h0s-3.1-3.43-3.1-3.43c-.04-.04-.07-.09-.08-.14-.02-.09-.01-.19.03-.28l1.71-3.45c.19-.39.7-.49,1.03-.21l3.61,3.14c10.91-10.17,34.71-8.24,42.01,3.62.27.44.27,1.02,0,1.46Z'
            fill='url(#sbf-fishfill)'
          />
          <g clipPath='url(#sbf-clip)'>
            <path
              d='M8 34C22 38 40 38 58 32L58 44L8 44Z'
              fill='#4595cf'
              fillOpacity='.35'
            />
            <path
              d='M26 28.5q1.6 2 3.2 0M30 27.4q1.6 2 3.2 0M34 26.8q1.6 2 3.2 0M28 32q1.6 2 3.2 0M32 31.4q1.6 2 3.2 0M36 31q1.6 2 3.2 0M30.5 35.2q1.6 2 3.2 0M34.5 35q1.6 2 3.2 0'
              fill='none'
              stroke='#2772af'
              strokeOpacity='.4'
              strokeWidth='.45'
              strokeLinecap='round'
            />
            <path
              d='M18 27.5C26 23.4 38 22.4 50 26.5'
              fill='none'
              stroke='#ffffff'
              strokeWidth='1'
              strokeLinecap='round'
            />
          </g>
          <circle fill='#2673b0' cx='44.96' cy='27.25' r='2.29' />
          <circle fill='#ffffff' cx='45.6' cy='26.6' r='.75' />
        </g>
      </g>
      <g className='sbf-fish__bubbles'>
        <path
          d='M218 136h44M230 142h20'
          fill='none'
          stroke='#7fbbe3'
          strokeOpacity='.35'
          strokeWidth='1.5'
          strokeLinecap='round'
        />
        <circle
          cx='206'
          cy='142'
          r='2.6'
          fill='none'
          stroke='#7fbbe3'
          strokeOpacity='.5'
          strokeWidth='1.2'
        />
        <circle
          cx='276'
          cy='140'
          r='3.6'
          fill='none'
          stroke='#7fbbe3'
          strokeOpacity='.45'
          strokeWidth='1.2'
        />
        <circle cx='274.9' cy='138.8' r='.9' fill='#dceefb' fillOpacity='.6' />
        <circle
          cx='286'
          cy='147'
          r='1.6'
          fill='none'
          stroke='#7fbbe3'
          strokeOpacity='.4'
          strokeWidth='1.2'
        />
      </g>
    </svg>
  );
}

export default FooterFishIllustration;
